import actionTypes from 'constants/actionTypes'

interface CullingState {
  depth: number
}

interface CullingAction {
  type: string
  payload?: {
    depth?: number
  }
}

const initialState: CullingState = {
  depth: 1,
}

const focus = (state: CullingState = initialState, action: CullingAction): CullingState => {
  switch (action.type) {
    case actionTypes.GRAPH.CULLING.RESET_DEPTH:
      return {
        depth: 1
      }
    case actionTypes.GRAPH.CULLING.SET_DEPTH:
      return {
        depth: action.payload?.depth ?? state.depth
      }
    case actionTypes.GRAPH.CULLING.INCREASE_DEPTH:
      return {
        depth: state.depth + 1
      }
    case actionTypes.GRAPH.CULLING.DECREASE_DEPTH:
      return {
        depth: state.depth - 1
      }
    default:
      return state
  }
}

export default focus
